export const SIDEBAR_LIST = {
	SITE_SETTINGS: {
		SETTING_NAME: 'SITE_SETTINGS',
		LABEL: 'Site Settings'
	},
	FLOOR_PRICING_CONFIG: {
		SETTING_NAME: 'FLOOR_PRICING_CONFIG',
		LABEL: 'Floor Pricing Config'
	},
	SERVICE_CONFIG: {
		SETTING_NAME: 'SERVICE_CONFIG',
		LABEL: 'Service Config'
	},
	MANUAL_FLOOR_RULES: {
		SETTING_NAME: 'MANUAL_FLOOR_RULES',
		LABEL: 'Manual Floor'
	}
};

//=========================================================

// FloorPriceConfig keys and constants =====

export const FLOOR_PRICING_CONSTANTS = {
	PAGES: {
		GENERAL: 'GENERAL',
		FLOOR_ENGINE_TYPE_SPLIT: 'FLOOR_ENGINE_TYPE_SPLIT'
	}
};

export const CONFIG_STRUCTURE_KEYS = {
	SITE_ID: 'siteId',
	SITE_DOMAIN: 'siteDomain',
	ENABLED: 'enabled',
	FLOOR_PRICING_CONFIG: 'floorPriceConfig',
	LOGGING_VERSION: 'loggingVersion',
	TRAFFIC_SPLIT: 'trafficSplit',
	FLOOR_ENGINE_TYPE_SPLIT: 'floorEngineTypeSplit',
	ENGINE_TYPE: 'engineType',
	INCREMENT_DECREMENT_ACTIVE: 'incrementDecrementActive',
	HB_WON_FLOOR_ACTIVE: 'hbWonFloorActive',
	DEFAULT_FLOOR_VALUE: 'defaultFloorValue',
	DIMENSION_RULES: 'dimensionRules',
	USE_BASE_MULTIPLIER: 'useBaseMultiplier',
	USE_DIMENSION_MULTIPLIER: 'useDimensionMultiplier',
	USE_BANNER_DRSD_MULTIPLIER: 'useBannerDRSDMultiplier',
	USE_HOURLY_BANNER_MULTIPLIER: 'useHourlyBannerMultiplier',
	DEFAULT_MULTIPLIER_VALUE: 'defaultMultiplierValue',
	FLOOR_PRICING_MODEL: 'floorPricingModel',
	CLUSTERING_RULES_ENABLED: 'clusteringRulesEnabled'
};

const HC_FLOORS = 'hcFloors';
const REFRESH_COUNT = 'refreshCount';
const ACTIVE_TABWISE_FLOORS = 'activeTabWiseFloors';
const CLUSTERING_FLOORS = 'clusteringFloors';
const MANUAL_FLOOR_ENGINE_TYPE = 'manualFloors';

export const MANDATORY_FP_CONFIG_KEYS = {
	[CLUSTERING_FLOORS]: [CONFIG_STRUCTURE_KEYS.CLUSTERING_RULES_ENABLED]
};

export const ALL_ENGINE_MODELS = [
	HC_FLOORS,
	REFRESH_COUNT,
	ACTIVE_TABWISE_FLOORS,
	CLUSTERING_FLOORS,
	MANUAL_FLOOR_ENGINE_TYPE
];

export const ENGINE_MODEL_KEYS_CONDITIONS = {
	[CONFIG_STRUCTURE_KEYS.ENGINE_TYPE]: [
		CLUSTERING_FLOORS,
		ACTIVE_TABWISE_FLOORS,
		REFRESH_COUNT,
		HC_FLOORS,
		MANUAL_FLOOR_ENGINE_TYPE
	],
	[CONFIG_STRUCTURE_KEYS.TRAFFIC_SPLIT]: [
		CLUSTERING_FLOORS,
		ACTIVE_TABWISE_FLOORS,
		REFRESH_COUNT,
		HC_FLOORS,
		MANUAL_FLOOR_ENGINE_TYPE
	],
	[CONFIG_STRUCTURE_KEYS.INCREMENT_DECREMENT_ACTIVE]: [
		CLUSTERING_FLOORS,
		ACTIVE_TABWISE_FLOORS,
		REFRESH_COUNT,
		HC_FLOORS,
		MANUAL_FLOOR_ENGINE_TYPE
	],
	[CONFIG_STRUCTURE_KEYS.HB_WON_FLOOR_ACTIVE]: [
		CLUSTERING_FLOORS,
		ACTIVE_TABWISE_FLOORS,
		REFRESH_COUNT,
		HC_FLOORS,
		MANUAL_FLOOR_ENGINE_TYPE
	],
	[CONFIG_STRUCTURE_KEYS.DEFAULT_FLOOR_VALUE]: [
		ACTIVE_TABWISE_FLOORS,
		REFRESH_COUNT,
		HC_FLOORS,
		MANUAL_FLOOR_ENGINE_TYPE
	],
	[CONFIG_STRUCTURE_KEYS.DIMENSION_RULES]: [
		CLUSTERING_FLOORS,
		ACTIVE_TABWISE_FLOORS,
		REFRESH_COUNT,
		HC_FLOORS
	],
	[CONFIG_STRUCTURE_KEYS.USE_BASE_MULTIPLIER]: [HC_FLOORS, MANUAL_FLOOR_ENGINE_TYPE],
	[CONFIG_STRUCTURE_KEYS.USE_DIMENSION_MULTIPLIER]: [HC_FLOORS, MANUAL_FLOOR_ENGINE_TYPE],
	[CONFIG_STRUCTURE_KEYS.USE_BANNER_DRSD_MULTIPLIER]: [HC_FLOORS],
	[CONFIG_STRUCTURE_KEYS.USE_HOURLY_BANNER_MULTIPLIER]: [HC_FLOORS],
	[CONFIG_STRUCTURE_KEYS.DEFAULT_MULTIPLIER_VALUE]: [HC_FLOORS, MANUAL_FLOOR_ENGINE_TYPE],
	[CONFIG_STRUCTURE_KEYS.FLOOR_PRICING_MODEL]: [HC_FLOORS],
	[CONFIG_STRUCTURE_KEYS.CLUSTERING_RULES_ENABLED]: [CLUSTERING_FLOORS]
};

export const FLOOR_PRICING_MODELS = ['passive', 'aggressive'];

export const DIMENSION_RULES_LIST = ['country', 'browser', 'platform'];

// TODO: Validate type of content inside Array as well
export const ENGINE_KEY_TYPES = {
	array: [CONFIG_STRUCTURE_KEYS.DIMENSION_RULES],
	number: [
		CONFIG_STRUCTURE_KEYS.DEFAULT_FLOOR_VALUE,
		CONFIG_STRUCTURE_KEYS.DEFAULT_MULTIPLIER_VALUE
	],
	boolean: [
		CONFIG_STRUCTURE_KEYS.INCREMENT_DECREMENT_ACTIVE,
		CONFIG_STRUCTURE_KEYS.HB_WON_FLOOR_ACTIVE,
		CONFIG_STRUCTURE_KEYS.USE_BASE_MULTIPLIER,
		CONFIG_STRUCTURE_KEYS.USE_DIMENSION_MULTIPLIER,
		CONFIG_STRUCTURE_KEYS.USE_BANNER_DRSD_MULTIPLIER,
		CONFIG_STRUCTURE_KEYS.USE_HOURLY_BANNER_MULTIPLIER,
		CONFIG_STRUCTURE_KEYS.CLUSTERING_RULES_ENABLED
	]
};

//=========================================================

//ServiceConfig keys and constants  =========
export const SERVICE_CONFIG_KEYS = {
	CONFIGS: 'configs',
	ENABLED: 'enabled',
	SERVICE_TYPE: 'serviceType',
	AD_UNITS: 'adUnits',
	DIMENSIONS: 'dimensions',
	COLUMNS: 'columns',
	DIMENSIONAL_COMBINATIONS: 'dimensionalCombinations',
	TIME_PERIOD_IN_DAYS: 'timePeriodInDays',
	CPM_MULTIPLIER: 'cpmMultiplier',
	MULTIPLIER_DIFFERENCE: 'multiplierDifference',
	DEFAULT_MIN_MULTIPLIER: 'defaultMinimumMultiplier',
	STARTING_MULTIPLIER: 'startingMultiplier',
	DATE_OFFSET: 'dateOffSet',
	ONLY_TOP_COUNTRIES: 'onlyTopCountries',
	SD_MULTIPLIER: 'sdMultiplier',
	SKIP_ECPM: 'skipEcpm',
	SKIP_FILL_RATE: 'skipFillRate',
	SKIP_REQUEST_ECPM: 'skipRequestEcpm',
	PROFITABLE_COMBINATIONS_ONLY: 'profitableCombinationsOnly',
	NTH_STANDARD_DEVIATION: 'nthStandardDeviation',
	THRESHOLD: 'threshold'
};

const BANNER_SERVICE = 'bannerService';
const BANNER_DRSD_SERVICE = 'bannerDimensionReductionViaStandardDeviation';
const BANNER_MDRSD_SERVICE = 'bannerMultiplierDimensionReductionViaStandardDeviation';

export const ALL_SERVICES = [BANNER_SERVICE, BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE];

export const MANDATORY_SERVICE_KEYS = {
	[BANNER_SERVICE]: [
		SERVICE_CONFIG_KEYS.AD_UNITS,
		SERVICE_CONFIG_KEYS.DIMENSIONS,
		SERVICE_CONFIG_KEYS.COLUMNS,
		SERVICE_CONFIG_KEYS.TIME_PERIOD_IN_DAYS
	],
	[BANNER_DRSD_SERVICE]: [SERVICE_CONFIG_KEYS.TIME_PERIOD_IN_DAYS, SERVICE_CONFIG_KEYS.DATE_OFFSET],
	[BANNER_MDRSD_SERVICE]: [SERVICE_CONFIG_KEYS.TIME_PERIOD_IN_DAYS, SERVICE_CONFIG_KEYS.DATE_OFFSET]
};

export const SERVICE_KEYS_CONDITIONS = {
	[SERVICE_CONFIG_KEYS.ENABLED]: [BANNER_SERVICE, BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.SERVICE_TYPE]: [BANNER_SERVICE, BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.AD_UNITS]: [BANNER_SERVICE],
	[SERVICE_CONFIG_KEYS.DIMENSIONS]: [BANNER_SERVICE],
	[SERVICE_CONFIG_KEYS.COLUMNS]: [BANNER_SERVICE],
	[SERVICE_CONFIG_KEYS.DIMENSIONAL_COMBINATIONS]: [BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.TIME_PERIOD_IN_DAYS]: [
		BANNER_SERVICE,
		BANNER_DRSD_SERVICE,
		BANNER_MDRSD_SERVICE
	],
	[SERVICE_CONFIG_KEYS.CPM_MULTIPLIER]: [BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.MULTIPLIER_DIFFERENCE]: [BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.DEFAULT_MIN_MULTIPLIER]: [BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.STARTING_MULTIPLIER]: [BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.DATE_OFFSET]: [BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.ONLY_TOP_COUNTRIES]: [BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.SD_MULTIPLIER]: [BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.SKIP_ECPM]: [BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.SKIP_FILL_RATE]: [BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.SKIP_REQUEST_ECPM]: [BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.PROFITABLE_COMBINATIONS_ONLY]: [BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.NTH_STANDARD_DEVIATION]: [BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE],
	[SERVICE_CONFIG_KEYS.THRESHOLD]: [BANNER_DRSD_SERVICE, BANNER_MDRSD_SERVICE]
};

export const DIMENSIONS_LIST = ['CUSTOM_CRITERIA', 'DATE', 'COUNTRY_NAME'];

export const COLUMNS_LIST = [
	'TOTAL_CODE_SERVED_COUNT',
	'TOTAL_INVENTORY_LEVEL_UNFILLED_IMPRESSIONS',
	'TOTAL_LINE_ITEM_LEVEL_CPM_AND_CPC_REVENUE',
	'TOTAL_LINE_ITEM_LEVEL_IMPRESSIONS',
	'TOTAL_LINE_ITEM_LEVEL_WITHOUT_CPD_AVERAGE_ECPM'
];

export const DIMENSIONAL_COMBINATION_LISTS = [
	'COUNTRY_DEVICE_BROWSER_HOUR_TABSTATUS_REFRESHCOUNT',
	'COUNTRY_DEVICE_BROWSER_HOUR_TABSTATUS',
	'COUNTRY_DEVICE_BROWSER_HOUR',
	'COUNTRY_DEVICE_BROWSER',
	'COUNTRY_DEVICE',
	'COUNTRY',
	'COUNTRY_BROWSER',
	'COUNTRY_HOUR',
	'DEFAULT_DEVICE_BROWSER_HOUR_TABSTATUS_REFRESHCOUNT',
	'DEFAULT_DEVICE_BROWSER_HOUR_TABSTATUS',
	'DEFAULT_DEVICE_BROWSER_HOUR',
	'DEFAULT_DEVICE_BROWSER',
	'DEFAULT_DEVICE',
	'DEFAULT',
	'COUNTRY_DEVICE_BROWSER_TABSTATUS_REFRESHCOUNT',
	'COUNTRY_DEVICE_BROWSER_TABSTATUS',
	'DEFAULT_DEVICE_BROWSER_TABSTATUS_REFRESHCOUNT',
	'DEFAULT_DEVICE_BROWSER_TABSTATUS'
];

export const SERVICE_KEY_TYPES = {
	array: [
		SERVICE_CONFIG_KEYS.AD_UNITS,
		SERVICE_CONFIG_KEYS.DIMENSIONS,
		SERVICE_CONFIG_KEYS.COLUMNS,
		SERVICE_CONFIG_KEYS.DIMENSIONAL_COMBINATIONS
	],
	number: [
		SERVICE_CONFIG_KEYS.TIME_PERIOD_IN_DAYS,
		SERVICE_CONFIG_KEYS.CPM_MULTIPLIER,
		SERVICE_CONFIG_KEYS.MULTIPLIER_DIFFERENCE,
		SERVICE_CONFIG_KEYS.DEFAULT_MIN_MULTIPLIER,
		SERVICE_CONFIG_KEYS.STARTING_MULTIPLIER,
		SERVICE_CONFIG_KEYS.DATE_OFFSET,
		SERVICE_CONFIG_KEYS.SD_MULTIPLIER,
		SERVICE_CONFIG_KEYS.NTH_STANDARD_DEVIATION,
		SERVICE_CONFIG_KEYS.THRESHOLD
	],
	boolean: [
		SERVICE_CONFIG_KEYS.ONLY_TOP_COUNTRIES,
		SERVICE_CONFIG_KEYS.SKIP_ECPM,
		SERVICE_CONFIG_KEYS.SKIP_FILL_RATE,
		SERVICE_CONFIG_KEYS.SKIP_REQUEST_ECPM,
		SERVICE_CONFIG_KEYS.PROFITABLE_COMBINATIONS_ONLY
	]
};
//=========================================================

//Manual Floor Rules Config keys and constants=============
export const MANUAL_FLOOR_KEYS = {
	MANUAL_FLOOR_RULES_KEY: 'manualFloorRules',
	AD_UNITS: 'adUnits',
	COUNTRY: 'countries',
	PLATFORM: 'platforms',
	FLOOR: 'floor'
};
//=========================================================

// Modes used for for logging
export const OPERATION_MODES = {
	SYNC_FP_MANUAL_FLOORS: 'SYNC_FP_MANUAL_FLOORS'
};
